export default "__VITE_ASSET__2C9lA8zQ__"